import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { DeleteBoardQueueGroupRequest } from '../types';

export const deleteBoardQueueGroup = async ({
  pathParams: { organisationId, boardId, queueGroupId },
}: DeleteBoardQueueGroupRequest) => {
  const url = `/api/v2/organisations/${organisationId}/boards/${boardId}/queue/groups/${queueGroupId}`;
  await apiAuthClient.delete(url);
};
